import { Component } from '@angular/core';

@Component({
    selector: 'no-access-page',
    templateUrl: './no-access-page.html',
    styleUrls: ['./no-access-page.scss'],
    standalone: false
})

export class NoAccessPageComponent {
    constructor(){}
}
